import React, { useMemo, useState } from 'react';
import { User } from 'lucide-react';
import SignedImage from '@/components/ipe/SignedImage';

function InitialAvatar({ displayName, className, size, imageClassName }) {
  const initial = String(displayName || '').trim().slice(0, 1).toUpperCase();
  return (
    <span
      className={`ipe-user-avatar ipe-user-avatar--initial${className ? ` ${className}` : ''}${imageClassName ? ` ${imageClassName}` : ''}`}
      style={{ width: size, height: size, fontSize: Math.round(size * 0.42) }}
      aria-hidden="true"
    >
      {initial && initial !== '+' ? initial : <User size={Math.round(size * 0.42)} strokeWidth={2} />}
    </span>
  );
}

export default function UserAvatar({
  avatarUrl,
  displayUrl,
  viewUrl,
  displayName = '',
  className = '',
  size = 52,
  imageClassName = '',
}) {
  const [imageFailed, setImageFailed] = useState(false);
  const raw = String(avatarUrl || '').trim();
  const signOptions = useMemo(() => ({
    displayUrl: displayUrl || viewUrl || '',
    viewUrl: viewUrl || displayUrl || '',
  }), [displayUrl, viewUrl]);

  const placeholder = (
    <InitialAvatar
      displayName={displayName}
      className={className}
      size={size}
      imageClassName={imageClassName}
    />
  );

  if (!raw || imageFailed) {
    return placeholder;
  }

  return (
    <SignedImage
      url={raw}
      displayUrl={signOptions.displayUrl}
      viewUrl={signOptions.viewUrl}
      alt=""
      className={`ipe-user-avatar ipe-user-avatar--image${className ? ` ${className}` : ''}${imageClassName ? ` ${imageClassName}` : ''}`}
      style={{ width: size, height: size }}
      loading="eager"
      loadingFallback={placeholder}
      fallback={placeholder}
      onError={() => setImageFailed(true)}
      aria-hidden="true"
    />
  );
}
